import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { GenericResponse } from '@otas/model/genericResponse';
import { PanchangamJson } from '@otas/model/panchang/panchangam-json';
@Injectable()
export class PanchangamResolverService  {

    constructor(private http: HttpClient) {
    }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<GenericResponse<PanchangamJson>> |
        Observable<Observable<GenericResponse<PanchangamJson>>> | Promise<Observable<GenericResponse<PanchangamJson>>> {
        return this.getPanchangam();
    }
    public getPanchangam(): Observable<GenericResponse<PanchangamJson>> {

        return this.http.get<GenericResponse<PanchangamJson>>(`panchangam`);

    }
}
